import React from "react";
import { Star, Quote, ShieldCheck, Zap, Lock, BadgeCheck } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "عبدالله المانع",
    city: "الرياض",
    text: "خدمة احترافية وسريعة جداً. استلمت السيولة خلال 10 دقائق فقط، وتعامل الفريق كان راقياً ومحترماً.",
    rating: 5,
    initials: "ع م",
  },
  {
    name: "سارة القحطاني",
    city: "جدة",
    text: "كنت محتاجة سيولة بسرعة، ميرال كروب وفرت لي الحل المثالي بطريقة شرعية وسهلة. شكراً لكم.",
    rating: 5,
    initials: "س ق",
  },
  {
    name: "فهد الشمري",
    city: "الدمام",
    text: "أفضل خدمة جربتها. شفافية كاملة في المبالغ والرسوم، والدعم عبر الواتساب ممتاز طول اليوم.",
    rating: 5,
    initials: "ف ش",
  },
  {
    name: "نورة العتيبي",
    city: "الرياض",
    text: "تجربة رائعة فعلاً. الإجراءات بسيطة جداً وبدون تعقيد، وحصلت على المبلغ بسرعة وبدون بنوك.",
    rating: 5,
    initials: "ن ع",
  },
];

const TRUST_BADGES = [
  { icon: BadgeCheck, title: "موثّق رسمياً", desc: "من وزارة التجارة" },
  { icon: Zap, title: "خدمة سريعة", desc: "نحن نختصر لك الوقت" },
  { icon: Lock, title: "بياناتك محمية", desc: "خصوصيتك تهمنا" },
  { icon: ShieldCheck, title: "متوافق شرعياً", desc: "معاملات شرعية واضحة" },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-20 md:py-28 bg-white" data-testid="testimonials-section">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="text-center mb-14 fade-up">
          <div className="inline-block text-brand-gold font-bold text-sm tracking-widest uppercase mb-3">
            آراء العملاء
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-brand-green leading-tight">
            خدمنا مئات العملاء بنجاح
          </h2>
          <p className="mt-3 text-base md:text-lg text-brand-ink/70 max-w-2xl mx-auto">
            ثقة عملائنا هي أغلى ما نملك — إليك ما يقوله بعضهم عن تجربتهم معنا.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i + 1}`}
              className="relative bg-brand-bg rounded-3xl p-6 md:p-8 border border-black/5 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 fade-up"
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <Quote className="absolute top-5 end-5 w-10 h-10 text-brand-gold/20" />

              <div className="flex items-center gap-1 mb-4">
                {[...Array(t.rating)].map((_, j) => (
                  <Star key={j} className="w-4 h-4 fill-brand-gold text-brand-gold" />
                ))}
              </div>

              <p className="text-brand-ink/85 leading-relaxed text-base md:text-lg">
                "{t.text}"
              </p>

              <div className="mt-6 flex items-center gap-3 pt-5 border-t border-black/10">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-brand-green to-brand-green-light flex items-center justify-center text-brand-gold font-heading font-extrabold">
                  {t.initials}
                </div>
                <div>
                  <div className="font-heading font-extrabold text-brand-green">{t.name}</div>
                  <div className="text-xs text-brand-ink/60 font-semibold">{t.city}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust badges row */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {TRUST_BADGES.map((b, i) => (
            <div
              key={i}
              data-testid={`trust-badge-${i + 1}`}
              className="text-center p-5 rounded-2xl bg-brand-bg border border-brand-gold/20 fade-up"
              style={{ animationDelay: `${0.4 + i * 0.08}s` }}
            >
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-brand-green text-brand-gold mb-3">
                <b.icon className="w-6 h-6" />
              </div>
              <div className="font-heading font-extrabold text-brand-green">{b.title}</div>
              <div className="text-xs text-brand-ink/60 mt-1">{b.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
